import * as React from "react";

const MiniMenu: React.FC = () => {
    return <svg width="12px" height="28px" viewBox="0 0 12 28" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Carousels/Standard" transform="translate(-187.000000, -329.000000)">
            <g transform="translate(187.250000, 329.000000)">
                <rect stroke="#C5C5C5" strokeWidth="0.799999952" transform="translate(5.500000, 14.000000) scale(-1, 1) translate(-5.500000, -14.000000) " x="0.399999976" y="0.399999976" width="10.2" height="27.2" rx="2"></rect>
                <circle fill="#494949" cx="5.5" cy="21.5" r="1.5"></circle>
                <circle fill="#494949" cx="5.5" cy="7.5" r="1.5"></circle>
                <circle fill="#494949" cx="5.5" cy="14.5" r="1.5"></circle>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(MiniMenu);
